/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_Oauth_2Inputs */

const en_svchip_oauth_2 = /** @type {(inputs: Svchip_Oauth_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OAuth 2`)
};

const ar_svchip_oauth_2 = /** @type {(inputs: Svchip_Oauth_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OAuth 2`)
};

const bn_svchip_oauth_2 = /** @type {(inputs: Svchip_Oauth_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OAuth 2`)
};

const de_svchip_oauth_2 = /** @type {(inputs: Svchip_Oauth_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OAuth 2`)
};

const es_svchip_oauth_2 = /** @type {(inputs: Svchip_Oauth_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OAuth 2`)
};

const fr_svchip_oauth_2 = /** @type {(inputs: Svchip_Oauth_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OAuth2`)
};

const pt_svchip_oauth_2 = /** @type {(inputs: Svchip_Oauth_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OAuth 2`)
};

const zh_svchip_oauth_2 = /** @type {(inputs: Svchip_Oauth_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OAuth 2`)
};

const tr_svchip_oauth_2 = /** @type {(inputs: Svchip_Oauth_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OAuth 2`)
};

const ru_svchip_oauth_2 = /** @type {(inputs: Svchip_Oauth_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OAuth 2`)
};

const pl_svchip_oauth_2 = /** @type {(inputs: Svchip_Oauth_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OAuth 2`)
};

/**
* | output |
* | --- |
* | "OAuth 2" |
*
* @param {Svchip_Oauth_2Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_oauth_2 = /** @type {((inputs?: Svchip_Oauth_2Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_Oauth_2Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_oauth_2(inputs)
	if (locale === "bn") return bn_svchip_oauth_2(inputs)
	if (locale === "de") return de_svchip_oauth_2(inputs)
	if (locale === "es") return es_svchip_oauth_2(inputs)
	if (locale === "fr") return fr_svchip_oauth_2(inputs)
	if (locale === "pt") return pt_svchip_oauth_2(inputs)
	if (locale === "zh") return zh_svchip_oauth_2(inputs)
	if (locale === "tr") return tr_svchip_oauth_2(inputs)
	if (locale === "ru") return ru_svchip_oauth_2(inputs)
	if (locale === "pl") return pl_svchip_oauth_2(inputs)
	return en_svchip_oauth_2(inputs)
});